import { types, flow, getRoot } from "mobx-state-tree";

const ApiStore = types.model({}).actions(self => ({
  fetch2: flow(function* fetch2(endpoint, userParams = {}) {
    // eslint-disable-next-line no-undef
    const baseUrl = `${process.env.REACT_APP_BACKEND_API_URL}`;
    const url = `${baseUrl}${endpoint}`;
    
    const token = userParams.token || getRoot(self).authStore.token();

    const headers = {
      "Authorization": token ? `Token ${token}` : null,
      "Content-Type": "application/json",
    };

    const params = {
      ...userParams,
      "headers": headers,
    };

    const res = yield window.fetch(url, params);
    
    if (!res.ok && res.status === 401) {
      getRoot(self).authStore.logout();
    }

    return Promise.resolve(res);
  }),

  fetch: flow(function* fetch(endpoint, params, on_success, on_err) {
    yield self.fetch2(endpoint, params);

    // eslint-disable-next-line no-undef
    const base_url = `${process.env.REACT_APP_BACKEND_API_URL}`;
    const url = `${base_url}${endpoint}`;

    const api_token = params.api_token || getRoot(self).authStore.user_token;

    const headers = {
      Authorization: api_token ? `Token ${api_token}` : null,
      "Content-Type": "application/json"
    };
    const combined_headers = new Headers({
      ...headers,
      ...(params.headers || {})
    });

    const combined_params = {
      ...params,
      headers: combined_headers
    };

    try {
      const res = yield window.fetch(url, combined_params);

      if (!res.ok && res.status === 401) {
        // getRoot(self).authStore.logout();
        throw Error(res.statusText);
      }

      yield Promise.resolve(on_success(yield res.json()))
    } catch (err) {
      yield Promise.resolve(on_err(err));
    }
  }),
}));

export { ApiStore };
